import { backendApi } from "@/services/api";
import { ArtefactKind } from "../../artefacts/kind";

const artefactNumbersApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["NumbersArtefactNumber"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      numbersArtefactNumberShow: build.query<
        ArtefactNumber,
        ShowArtefactNumberRequest
      >({
        query: (request) => ({
          url: `/numbers/artefact-number`,
          method: "GET",
          params: request,
        }),
        providesTags: ["NumbersArtefactNumber"],
      }),
    }),
  });

export const { useNumbersArtefactNumberShowQuery } = artefactNumbersApi;

export interface ArtefactNumber {
  artefactId: string; // uuid.UUID wird in TS als string dargestellt
  artefactKind: ArtefactKind; // Enum oder Typ aus deinem Projekt
  processNumber: string;
  sequenceValue: number;
  string: string;
}

export interface ShowArtefactNumberRequest {
  artefactId: string;
  artefactKind: ArtefactKind;
}
